import { Form } from "antd";
import type { FormInstance } from "antd/es/form/Form";
import type { FC, PropsWithChildren } from "react";

import type { CommonFormField, ConditionalFieldAttributes } from "../../types/types";
import { getExpressionsFromCondition, resolveCondition } from "./conditionals_old";

type ConditionalWrapperProps = Readonly<{
    fieldConfig: CommonFormField;
}> &
    PropsWithChildren;

export const isFieldVisible = (formValues: object, fieldConfigAttributes?: ConditionalFieldAttributes) => {
    if (!fieldConfigAttributes?.condition || !fieldConfigAttributes?.watchedFields) {
        return true;
    }

    const { expressions, operators } = getExpressionsFromCondition(fieldConfigAttributes.watchedFields, fieldConfigAttributes.condition);
    const resolvedConditionString = resolveCondition(expressions, operators, formValues);

    try {
        // eslint-disable-next-line
        const result = eval(resolvedConditionString);
        return result;
    } catch (error) {
        return false;
    }
};

export const ConditionalWrapper: FC<ConditionalWrapperProps> = ({ fieldConfig, children }) => {
    return (
        <Form.Item
            noStyle
            shouldUpdate={(prevFormValues, currentFormValues) => {
                return (
                    prevFormValues[fieldConfig.name] === undefined ||
                    fieldConfig.attributes?.watchedFields
                        ?.map(
                            (field) =>
                                currentFormValues[field] === undefined ||
                                prevFormValues[field] === undefined ||
                                prevFormValues[field] !== currentFormValues[field],
                        )
                        .some((field) => field) ||
                    false
                );
            }}
        >
            {(form: FormInstance) => {
                return isFieldVisible(form.getFieldsValue(true), fieldConfig.attributes) ? children : null;
            }}
        </Form.Item>
    );
};
